import { cn } from '@/shared/lib';

/** Скелетон загрузки (README «Состояния загрузки»: DS задаёт --loading-pattern: skeleton). */
export function Skeleton({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn('block rounded-8 bg-surface-sunken animate-skeleton', className)}
    />
  );
}
